import { render, staticRenderFns } from "./ErrorContainer.vue?vue&type=template&id=bc9bd648&scoped=true"
import script from "./ErrorContainer.js?vue&type=script&lang=js&external"
export * from "./ErrorContainer.js?vue&type=script&lang=js&external"
import style0 from "./ErrorContainer.scss?vue&type=style&index=0&id=bc9bd648&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc9bd648",
  null
  
)

export default component.exports